<template>
  <div>
    <ValidationObserver ref="formServiceValidator" class="w-100">
      <form class="needs-validation" validate>
        <div class="container-table-striped w-100">
          <div class="table-hover">
            <table class="table content-table-striped table-striped mb-5">
              <thead>
                <tr class="row global-thead-dark thead-property">
                  <th class="col-md-4">
                    <span class="d-flex bold">Tipo de Servicio</span>
                  </th>
                  <th class="col-md-5">
                    <span class="d-flex bold">Servicio</span>
                  </th>
                  <th class="col-md-3" />
                </tr>
              </thead>

              <tbody v-if="services.length > 0" ref="container">
                <tr
                  v-for="(service, index) in services"
                  :key="index"
                  class="row"
                >
                  <template v-if="!service.isNew">
                    <td class="firstElement col-md-4 text-left">
                      <div firstElement>
                        <div class="ml-3">
                          <span>{{ service.serviceTypeName }}</span>
                        </div>
                      </div>
                    </td>

                    <td class="col-md-4 text-left">
                      <div class="ml-3">
                        <span>{{ service.disciplineTypeName }}</span>
                      </div>
                    </td>
                    <td class="col-md-4 text-right">
                      <button
                        v-if="formMode == 1"
                        class="btn btn-dropdown-actions dropdown-toggle pt-1"
                        type="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right pb-0">
                        <a
                          class="drop-item"
                          href="#"
                          @click="removeItem(index, false)"
                        >
                          <i class="fas fa-times-circle text-red pr-1" />
                          <span>Eliminar</span>
                        </a>
                      </div>
                    </td>
                  </template>

                  <template v-if="service.isNew">
                    <td class="col-md-4 text-left">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="SelectSeviceType"
                        rules="required"
                      >
                        <CustomDropDown
                          v-model="service.serviceType"
                          placeholder="Seleccionar"
                          fieldkey="id"
                          required
                          fieldname="serviceCategoryName"
                          :options="serviceTypeItems"
                          :error="errors[0]"
                          :custom-error-msg="errorMsgs['SelectSeviceType']"
                        />
                      </ValidationProvider>
                    </td>
                    <td class="col-md-4 text-left">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="SelectDiscipline"
                        rules="required"
                      >
                        <CustomDropDown
                          v-model="service.disciplineTypeCd"
                          placeholder="Seleccionar"
                          fieldkey="id"
                          required
                          fieldname="disciplineName"
                          :options="disciplines(service)"
                          :error="errors[0]"
                          :custom-error-msg="errorMsgs['SelectDiscipline']"
                        />
                      </ValidationProvider>
                    </td>
                    <td class="col-md-4 text-right">
                      <div>
                        <ActionButton
                          class="outline-danger mr-3"
                          i="fas fa-times-circle mr-2"
                          type="button"
                          @click="removeItem(index, true)"
                        >
                          Cancelar
                        </ActionButton>

                        <ActionButton
                          min-width="94px"
                          class="success"
                          type="button"
                          @click="add(service)"
                        >
                          Añadir
                        </ActionButton>
                      </div>
                    </td>
                  </template>
                </tr>
              </tbody>
              <tfoot v-if="services.length == 0">
                <tr>
                  <td colspan="3" class="text-center">
                    <span>No hay Servicios.</span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="w-100 text-right plus-btn">
          <ActionButton
            v-if="formMode == 1 && !isInsertModeVisible"
            class="success"
            i="fas fa-file-plus"
            type="button"
            @click="addNewService"
          >
            Añadir
          </ActionButton>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomAlert from '@/mixin/alert.mixin';

export default {
  name: 'ServicesAffirmativeLetter',
  mixins: [CustomAlert],
  data() {
    return {
      isInsertMode: false,
      serviceTypeItems: [],
      errorMsgs: {
        SelectDiscipline: 'Favor de seleccionar el servicio. (190706)',
        SelectSeviceType: 'Favor de seleccionar el tipo de servicio. (190705)',
      },
    };
  },
  mounted() {
    this.fetchServiceCategories();
  },
  props: {
    services: {
      type: Array,
      required: true,
    },
    formMode: {
      type: Number,
      required: true,
    },
  },
  components: {
    ActionButton,
    ValidationProvider,
    CustomDropDown,
    ValidationObserver,
  },
  computed: {
    isInsertModeVisible() {
      return this.isInsertMode;
    },
  },
  methods: {
    async fetchServiceCategories() {
      await this.$ApiGet('/api/affirmativeletters/serviceCategories')
        .then((res) => {
          this.serviceTypeItems = res.data ? res.data : [];
        })
        .catch((err) => {
          this.response = err;
        });
    },
    disciplines: function(service) {
      if (
        service.serviceType &&
        service.serviceType.disciplineTypes &&
        service.serviceType.disciplineTypes.length > 0
      )
        return service.serviceType.disciplineTypes.filter((discipline) => {
          return !this.services.some(
            (x) => x.disciplineTypeCd === discipline.id && !x.isNew
          );
        });
      else return [];
    },
    addNewService() {
      this.services.push({
        isNew: true,
      });
      this.$emit('addService', false);
      this.isInsertMode = true;
    },
    async add(item) {
      const isValid = await this.$refs.formServiceValidator.validate();

      if (isValid) {
        if (item.serviceType && item.disciplineTypeCd) {
          let discipline = item.serviceType.disciplineTypes.filter(
            (discipline) => {
              return discipline.id == item.disciplineTypeCd.id;
            }
          );

          if (discipline.length > 0) {
            item.isNew = false;
            item.serviceTypeCd = item.serviceType.serviceCategoryId;
            item.serviceTypeName = item.serviceType.serviceCategoryName;
            item.disciplineTypeName = discipline[0].disciplineName;
            item.disciplineTypeCd = discipline[0].id;
            this.isInsertMode = false;
            this.$emit('addService', true);
          }
        }
      }
    },

    async removeItem(index, insert) {
      if (insert) {
        this.$delete(this.services, index);
        this.isInsertMode = false;
      } else {
        let question =
          '¿Está seguro que desea eliminar el servicio documentado?';
        let alertResponse = await CustomAlert.methods.ShowCancelModal(
          'Atención',
          question,
          'Sí',
          'No'
        );
        if (alertResponse) {
          this.$delete(this.services, index);
          this.ShowToast(
            '',
            'Los datos fueron eliminados exitosamente.',
            'success'
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.plus-btn {
  padding-right: 1px;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-danger-outline {
  height: 38px;
  border: 1px solid #c9545e !important;
  color: #c9545e;
}

.text-red {
  color: #c9545e;
}

.btn-danger-outline:hover {
  background: #c9545e;
  border: 1px solid #c9545e;
  color: #fff;
}
</style>
